<template>
  <div class="container">
      <div class="dateBox">
          <div class="bodyViewWscroll" ref="bodyViewWscroll">
                <div class="scrollTab" ref="scrollTab" >
                        <div :ref="`scrollItem_${index}`"
                            v-for="(item,index) in selectDataArr" :key="index" >
                                <div  class="scrollItem" @click="selectDate(item.date)">
                                    <span v-if="index==selectDataArr.length-1" :class="['scrollItem_t',item.date == activeDate?'scrollItem_t1':'']">今天</span>
                                    <span v-else-if="index==selectDataArr.length-2" :class="['scrollItem_t',item.date == activeDate?'scrollItem_t1':'']">昨天</span>
                                    <span v-else :class="['scrollItem_t',item.date == activeDate?'scrollItem_t1':'']">{{item.week}}</span>
                                    <span :class="['scrollItem_b',item.date == activeDate?'scrollItem_t1':'']">{{item.day}}</span>
                                    <span class="scrollItem_l" v-if="item.date == activeDate"></span>
                                </div>
                        </div>
                </div>
          </div>
          <!-- :style="{'marginLeft':'-'+scrollLeft}" -->
        <!-- <div class="box_left" :style="{'marginLeft':''+scrollLeft}" >
          <div
            class="scroll_data_item"
            v-for="(item,index) in selectDataArr"
            :key="index"
            @click="selectDate(item.date)"
          >
            <span v-if="index==selectDataArr.length-1" class="item_t">今天</span>
            <span v-else-if="index==selectDataArr.length-2" class="item_t">昨天</span>
            <span v-else class="item_t">{{item.week}}</span>
            <span class="item_b">{{item.day}}</span>
            <span class="SignLnitem_l" v-if="item.date == activeDate"></span>
          </div>
        </div>-->
        <div class="select_data border-left" @click.stop="changeDate">
          <img class="dateIcon" src="../../../assets/images/icon_arrows_unfold.png" />
        </div>
      </div>
     <div class="topLine"></div>
    <!-- ,cur==index ? 'tablecur' :'' -->
     <div :class="['tabbar','tabbar_nbg']">
            <div
            :class="['tabbar_list']"
            v-for="(item,index) of tabBar"
            :key="index"
            @click="tabClick(index)"
            >
                <div class="numDiv">
                    <span class="titelSpan">{{item}}</span>
                    <span v-if="index ==0 || index==1" class="numSpan">{{tabBar1[index]}}</span>
                    <span v-else class="numSpan1">{{tabBar1[index]}}</span>
                </div>
                <i v-if="cur==index" class="iClasss"></i>
                <i v-else class="iClasss1"></i>
     </div>
     <div class="tableView">
         <Scroll class="Scroll"  :pullup="false" :pulldown="false">
            <div class="tableView_top">
                <div class="tableView_top_div1">
                    <span class="tableView_top_span1">姓名</span>
                </div>
                <div class="tableView_top_div1">
                    <span class="tableView_top_span1">部门</span>
                </div>
                <div class="tableView_top_div2">
                    <span class="tableView_top_span1">签到时间</span>
                </div>
            </div>
            <section  class="list_cell" v-for="(item,index) in showList" :key="index"  >
                <div class="list_cell_div1">
                    <img class="list_cell_icon" :src="item.photoPath?item.photoPath:require(`../../../assets/images/img_default_face_${common.theme}.jpg`)"  />
                    <span class="list_cell_span1">{{item.userName}}</span>
                </div>
                <div class="list_cell_div2">
                    <span class="list_cell_span2">{{item.department?item.department:'-'}}</span>
                </div>
                <div class="list_cell_div3">
                    <span v-if="item.signTime" class="list_cell_span5">{{item.signTime |signTime}}</span>
                    <span v-if="item.status==3" class="list_cell_span4">迟到</span>
                    <span v-if="item.status==0" class="list_cell_span3">未打卡</span>
                </div>
                <div class="list_cell_line"></div>
            </section>

         </Scroll>
     </div>
  </div>

    <!-- 日期控件 :start-date="toView" -->
    <yd-datetime
      style="display:none;"
      ref="datetime"
      @input="bindDateChange"
      type="date"
      v-model="date"
      start-date="2020-01-01"
      :end-date="endDate"
       ></yd-datetime>

  </div>
</template>
<script>
import Tabbar from "@/pages/smartOffice/StruggleReport/StruggleTabbar.vue";
import Scroll from "@/components/scroll";
import BScroll from "better-scroll";
import util from "@/utils/util";
import {teamReport} from "@/utils/api";
import {mapState} from 'vuex';
export default {
    data(){
        return {
            newDate:'',
            newDatestr:'',
            scrollLeft: 0,
            signinType:0,
            scroll:'',
            tabBar: ['全部', '正常', '未打卡', '迟到'],
            tabBar1:[0, 0, 0, 0],
            all:0,
            normal:0,
            unNormal:0,
            late:0,
            signinList:[],
            orgId:'',
            roleId:'',
            showList:[],
            cur:0,
            selectDataArr: [], //可选日期数组
            activeDate:[],
            date: util.formatTime(new Date(), 4),
            toView: util.formatTime(new Date(), 4),
            endDate: util.formatTime(new Date(), 4),
        }
    },
    components:{
        Tabbar,
        Scroll
    },
    computed: {
        ...mapState({
        common: state => state.common
        })
    },
    mounted(){
        this.$nextTick(() => {
            this.personScroll();
        });
        //this.getData();
    },
    filters: {
       signTimeDate: function (value) {
            if(!value){
                return '';
            }
            return util.formatTime(new Date(value), 255)
       },
       signTime: function (value) {
           if(!value){
                return '';
           }
           return util.formatTime(new Date(value),22)
       },
    },
    created(){
         this.roleId = this.common.userTenantInfo.roleId;
        if(this.roleId=='2'){
            this.orgId='';
        }else{
            this.orgId = this.common.userTenantInfo.departmentId
        }
        this.newDate = new Date();
        this.newDatestr = util.formatTime(new Date(),4)
        this.getSelectDataArr();
        this.getteamReportAction();
    },
     methods:{
         // 得到可选时间日期
        getSelectDataArr() {
                let arr = [];
                var targetDay = new Date().getTime() -30* 1000 * 24 * 60 * 60 ;
               // console.log("targetDay  ===" + new Date(targetDay));
                for (var i = 0; i <= 30; i++) {
                    var idata = new Date(targetDay+ i* 1000 * 24 * 60 * 60);
                  //  console.log("idata  ===" + idata);
                    arr.push({
                        date: util.formatTime(idata,4),
                        week: this.getWeek(idata),
                        day: idata.getDate(),
                    });
                    if(util.formatTime(idata,4)==this.newDatestr){
                        this.activeDate = util.formatTime(idata,4);
                        //  setTimeout(() => {
                        //     let a = this.$refs[`scrollItem_${i}`][0];
                        //     console.log(a);
                        //     this.scroll.scrollToElement(a, 0, 0)
                        // }, 300)
                        // if(i>24){
                        //     this.scrollLeft = -100 * 24.5/2 //+'px'
                        // }else{
                        //     this.scrollLeft = -100 * i /2  //+'px'
                        // }
                    }
                }
           // }
            this.selectDataArr = arr;
            setTimeout(() => {
                    this.personScroll();
            }, 100)
            console.log(JSON.stringify(this.selectDataArr));
        },
        selectDate(data) {
            this.activeDate = data;
            this.newDatestr =  data;
            this.getteamReportAction();
            //util.formatTime(new Date(),4)

         },
          // 日期获取周几
        getWeek(value) {
            let end = ''
            switch (
                value.getDay()
            ) {
                case 1:
                end = "一";
                break;
                case 2:
                end = "二";
                break;
                case 3:
                end = "三";
                break;
                case 4:
                end = "四";
                break;
                case 5:
                end = "五";
                break;
                case 6:
                end = "六";
                break;
                case 0:
                end = "日";
                break;
                default:
            }
            return end
        },
        changeDate() {
             this.$refs.datetime.open();
        },
        // 日期切换
        bindDateChange(val) {
            this.selectDataArr.forEach((item, index) => {
                if (val == item.date) {
                    setTimeout(() => {
                         let a = this.$refs[`scrollItem_${index}`][0]
                         console.log(a);
                        this.scroll.scrollToElement(a, 0, 0)
                    }, 300)

                   //this.scrollLeft = 100 +'px'
                   //100 * index / 100 + "rem";
                  // this.scroll.scrollTo(100 * index, 0, 3000, 'swipe')
                   if(index>24){
                       //this.scrollLeft = -100 * 26/2 +'px'
                      // this.scrollLeft = 0 +'px'
                       // this.scrollLeft = 100 * (30-index) /2 +'px'
                   }else{
                       // this.scrollLeft = 100 * (30-index) /2 +'px'
                      //this.scrollLeft = -100 * index /2 +'px'
                   }
                }
            this.activeDate = val;
            this.newDatestr =  val;
            this.getteamReportAction();

            });
        },
        tabClick(index){
            this.cur =index;
            this.reSetShowList();
        },
        reSetShowList(){
            if(this.cur==0){
                this.showList = this.signinList;
            }else if(this.cur==1){
                var list =[];
                for (var i=0;i<this.signinList.length;i++){
                    var item = this.signinList[i];
                    if(item.status==2){
                        list.push(item);
                    }
                }
                this.showList=list;
            }else if(this.cur ==2){
                var list =[];
                for (var i=0;i<this.signinList.length;i++){
                    var item = this.signinList[i];
                    if(item.status==0){
                        list.push(item);
                    }
                }
                this.showList=list;
            }else if(this.cur ==3){
                 var list =[];
                for (var i=0;i<this.signinList.length;i++){
                    var item = this.signinList[i];
                    if(item.status==3){
                        list.push(item);
                    }
                }
                this.showList=list;
            }
        },
        getteamReportAction(){
             let params = {
                // companyId:'2',
                companyId:this.common.userTenantInfo.companyId,
                orgId:this.orgId,
                queryDate:this.newDatestr,
            }
           // console.log('params == ' +JSON.stringify(params))
            teamReport(params).then(res => {
                if (res.res.code === 10000 && res.body) {
                   this.normal = res.body.normal;
                   this.unNormal = res.body.unNormal;
                   this.late = res.body.late;
                   this.all =  this.normal+ this.unNormal+ this.late
                   this.tabBar1[0]=this.all;
                   this.tabBar1[1]=this.normal;
                   this.tabBar1[2]=this.unNormal;
                   this.tabBar1[3]=this.late;
                   this.signinList = res.body.signinList;
                   this.reSetShowList();
                }
            });
        },
         personScroll() {
        // 默认有六个li子元素，每个子元素的宽度为120px
            let width = 0;
            //10 * 128;
            if(!this.$refs.scrollTab){
                return;
            }
             for(var i=0;i<this.selectDataArr.length;i++){
               width= width+  this.$refs[`scrollItem_${i}`][0].clientWidth ;
               // width =width+56+ 4*26+20;
                console.log(width);

            }

            this.$refs.scrollTab.style.width = width + "px";
            // this.$nextTick 是一个异步函数，为了确保 DOM 已经渲染
            this.$nextTick(() => {
                if (!this.scroll) {
                this.scroll = new BScroll(this.$refs.bodyViewWscroll, {
                    startX: 0,
                    click: true,
                    scrollX: true,
                    // 忽略竖直方向的滚动
                    scrollY: false,
                    eventPassthrough: "vertical"
                });
                } else {
                    this.scroll.refresh();
                }
            });
        },
     }
}
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container{
    height:100vh;
    background:#FFFFFF;
}
.tableView{
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
}
.Scroll{
    flex: 1;
    margin-bottom: 20px;
}
.tableView_top{
    width: 100%;
    height: 68px;
    flex-direction: row;
    display: flex;
    background:rgba(248,248,248,1);
}
.tableView_top_div1{
    width:275px;
    height:68px;
    background:rgba(248,248,248,1);
    display: flex;
}
.tableView_top_span1{
    width:275px;
    height:68px;
    text-align: center;
    font-size:24px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height: 68px;
}

.tableView_top_div2{
    width:200px;
    height:68px;
    background:rgba(248,248,248,1);
    display: flex;
}
.tableView_top_span2{
    width:200px;
    height:68px;
    text-align: center;
    font-size:24px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height: 68px;
}
.list_cell{
    width:750px;
    height:120px;
    background:rgba(255,255,255,1);
    display: flex;
    position: relative;
    flex-direction: row;
}
.list_cell_div1{
    width:275px;
    height:120px;
    flex-direction: row;
    display: flex;
}
.list_cell_icon{
    margin-left: 28px;
    margin-top: 20px;
    width:80px;
    height:80px;
    border-radius: 40px;
    // background:rgba(202,213,255,1);
   // border:1px solid rgba(182,196,248,1);
}
.list_cell_span1{
    margin-left: 20px;
    margin-top: 40px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.list_cell_div2{
    width:275px;
    height:120px;
    flex-direction: row;
    display: flex;
}
.list_cell_span2{
    width:275px;
    margin-top: 40px;
    height:40px;
    font-size:28px;
    text-align: center;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.list_cell_div3{
    width:200px;
    height:120px;
    flex-direction: column;
    justify-content: center;
    justify-items: center;
    align-items: center;
    display: flex;
}
.list_cell_span3{
    width:80px;
    height:40px;
    background:rgba(153,153,153,1);
    border-radius:20px;
    text-align: center;
    font-size:22px;
    font-weight:500;
    color:rgba(250,250,250,1);
    line-height: 40px;
}
.list_cell_span4{
    width:80px;
    height:40px;
    background:#FD9838;
    border-radius:20px;
    text-align: center;
    font-size:22px;
    font-weight:500;
    margin-top: 2px;
    color:rgba(250,250,250,1);
    line-height: 40px;
}
.list_cell_span5{
    width:80px;
    height:40px;
    font-size:28px;
    font-weight:400;
    margin-bottom: 2px;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.list_cell_line{
    position: absolute;
    left: 28px;
    bottom: 0px;
    width:694px;
    height:2px;
    background:rgba(240,240,240,1);
}

//
//
.topLine{
    width:750px;
    height:1px;
    background:rgba(234,234,234,1);
}
.dateBox {
  //height: 88px;
  position: relative;
  .flex();
  width: 100%;
  align-items: center;
  overflow: hidden;
}

.box_left {
  height: 88px;
  .flex();
  flex: 1;
  //width: 3000px;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
.scroll_data_item {
  width: 100px;
  height: 100px;
  display: block;
  position: relative;
  text-align: center;
  overflow: hidden;
  flex-shrink: 0;
}
.scroll_data_item span {
  display: block;
}
.item_t {
  font-size: 22px;
  color: rgba(102, 102, 102, 1);
  line-height: 32px;
  margin-top: 12px;
}
.item_b {
  height: 34px;
  font-size: 24px;
  color: rgba(102, 102, 102, 1);
  line-height: 34prx;
}
.SignLnitem_l {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
  width: 32px;
  height: 6px;
  background: #1740DA;
}
.select_data {
     position: absolute;
     right: 0;
     top: 0;
     height: 88px;
     width: 88px;
    .flex();
    background-color: white;
    justify-content: center;
    align-items: center;
//   position: relative;
//   height: 88px;
//   width: 88px;
//   .flex();
//   justify-content: center;
//   align-items: center;
}
.picker span {
  height: 60px;
  font-size: 44px;
  color: rgba(51, 51, 51, 1);
  line-height: 60px;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  bottom: 0;
  opacity: 0;
}
.dateIcon {
  width: 32px;
  height: 32px;
  display: block;
}


.tabbar {
  .flex();
  justify-content: center;
  width: 100%;
  height: 100px;
//   background-color: blue;
  margin: 0 auto;
  background: #fff;
  .tabbar_list {
    .flex(column);
    text-align: center;
    position: relative;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    // background-color: blue;
    padding-top: 26px;
    padding-bottom: 26px;
    .numDiv{
        width: 100;
        height: 40px;
        // background-color: red;
        flex-direction: row;
        display: flex;
        .titelSpan{
            height: 40px;
            line-height: 40px;
            color: @color9;
            margin-right: 8px ;
        }
        .numSpan{
            height:40px;
            font-size:28px;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:40px;
        }
        .numSpan1{
            height:40px;
            font-size:28px;
            font-weight:500;
            color:rgba(253,152,56,1);
            line-height:40px;
        }
    }
    // span {
    //   height: 40px;
    //   line-height: 40px;
    //   color: @color9;
    // }
    .iClasss1 {
      width: 32px;
      height: 6px;
      background: transparent;
    }

  }
}
.iClasss{
        position:absolute;
        bottom: 0px;
        left: 77px;
        width: 32px;
        height: 6px;
        background: #1740DA;
}
.tabbar_nbg{
  background:transparent;
  .cur{
    i{
      background:@color17 !important;
    }
  }
}

//
 .bodyViewWscroll{
        height: 100px;
        width:662px;
        // background-color: red;
        // display: flex;
        align-items: center;
        .scrollTab {
            height: 100px;
            // background-color: orange;
            display: flex;
            flex-direction: row;
           // align-items: center;
        }
         .scrollItem{
            display: flex;
            width: 100px;
            height: 100px;
            flex-direction: column;
            // display: block;
            // position: relative;
           // text-align: center;
           // overflow: hidden;
            //flex-shrink: 0;
            .scrollItem_t{
                margin-top: 16px;
                text-align: center;
                width:100px;
                height:34px;
                font-size:24px;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:34px;

            }
            .scrollItem_b{
                text-align: center;
                width:100px;
                height:34px;
                font-size:24px;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:34px;
            }
            .scrollItem_t1{
                color:#333333;
            }
            .scrollItem_l{
                margin-top: 12px;
                margin-left: 34px;
                width: 32px;
                height: 6px;
                background: #1740DA;

            }
         }
    }


</style>